exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".homepage-cssmodule-homepage-component-28L4s{padding-top:10px;padding-bottom:10px;border:none}.homepage-cssmodule-col-pad-top-2NwSw{padding-top:5px}.homepage-cssmodule-welcome-text-1Z6Id{color:#fff;position:absolute;top:0;padding-left:15px}.homepage-cssmodule-welcome-text-1Z6Id .homepage-cssmodule-header-g7eMi{color:#ff7300}.homepage-cssmodule-welcome-text-1Z6Id .homepage-cssmodule-content-rJH3Q{max-width:650px;padding-top:15px}", ""]);

// exports
exports.locals = {
	"homepage-component": "homepage-cssmodule-homepage-component-28L4s",
	"col-pad-top": "homepage-cssmodule-col-pad-top-2NwSw",
	"welcome-text": "homepage-cssmodule-welcome-text-1Z6Id",
	"header": "homepage-cssmodule-header-g7eMi",
	"content": "homepage-cssmodule-content-rJH3Q"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/Home/homepage.cssmodule.scss
// module id = 602
// module chunks = 0